import React, { useEffect } from 'react';
import { topNav } from '../assets/data/nav-items';
import { useDispatch, useSelector } from 'react-redux';
import { clearUser, getUser } from '../features/auth/authSlice';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/images/mah-wht.png';
import { VisitorLimits } from '../components';

const Navbar = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);

  useEffect(() => {
    dispatch(getUser());
  }, [dispatch]);

  const handleLogout = () => {
    dispatch(clearUser());
  };

  const filteredNavItems = topNav.filter((item) => {
    return item.roles.includes(user?.role);
  });

  // Check if user is a visitor
  const isVisitor = user?.role === 'visitor';

  return (
    <header className='flex items-center justify-between w-full fixed top-0 left-0 right-0 z-50 h-16 px-6 bg-dark-500 border-b border-dark-400 shadow-medium '>
      {/* Left side - Logo and Navigation */}
      <div className='flex items-center space-x-8'>
        {/* Logo */}
        <div className='flex items-center'>
          <img src={logo} alt='Logo' className='w-10 h-10 object-contain' />
        </div>
                         
        {/* Navigation Links */}
        <nav className='flex items-center space-x-2'>
          {filteredNavItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Link
                key={item.label}
                to={item.path}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                  isActive
                    ? 'bg-neutral-800 text-white shadow-soft'
                    : 'text-neutral-300 hover:text-white hover:bg-neutral-700'
                }`}
              >
                {item.icon && (
                  <span className='text-base opacity-80'>
                    {item.icon}
                  </span>
                )}
                <span className='capitalize tracking-wide'>
                  {item.label}
                </span>
              </Link>
            );
          })}
        </nav>
      </div>

      {/* Center - Visitor Limits Component (only show for visitors) */}
      <div className='absolute left-1/2 transform -translate-x-1/2'>
        {isVisitor && <VisitorLimits />}
      </div>

      {/* Right side - User info and Logout */}
      <div className='flex items-center space-x-4'>
        {user && (
          <div className='text-right'>
            <p className='text-neutral-400 text-xs uppercase tracking-wider'>
              Welcome
            </p>
            <p className='text-white text-sm font-semibold'>
              {user.name}
            </p>
          </div>
        )}
                         
        <button
          onClick={handleLogout}
          className='flex items-center px-4 py-2 bg-neutral-200 hover:bg-neutral-300 text-dark-400 hover:text-dark-500 font-medium text-sm rounded-lg transition-all duration-200 shadow-soft hover:shadow-medium border border-neutral-300 hover:border-neutral-400'
        >
          <span>Logout</span>
        </button>
      </div>
    </header>
  );
};

export default Navbar;